setEmailSignupVideoPreviewCount